var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlacement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.616 16C1.15533 16 0.771 15.846 0.463 15.538C0.155 15.23 0.000666667 14.8453 0 14.384V1.616C0 1.15533 0.154333 0.771 0.463 0.463C0.771667 0.155 1.156 0.000666667 1.616 0H14.385C14.845 0 15.2293 0.154333 15.538 0.463C15.8467 0.771667 16.0007 1.156 16 1.616V14.385C16 14.845 15.846 15.2293 15.538 15.538C15.23 15.8467 14.8453 16.0007 14.384 16H1.616ZM4.308 12.5H11.846C12.008 12.5 12.126 12.4277 12.2 12.283C12.274 12.1383 12.264 11.995 12.17 11.853L10.15 9.141C10.0633 9.033 9.95567 8.979 9.827 8.979C9.699 8.979 9.59133 9.033 9.504 9.141L7.212 12.039L5.785 10.314C5.69767 10.2187 5.593 10.171 5.471 10.171C5.34967 10.171 5.24533 10.225 5.158 10.333L4.004 11.853C3.896 11.995 3.87933 12.1383 3.954 12.283C4.02867 12.4277 4.14667 12.5 4.308 12.5Z",
    fill: "#C3CDDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlacement);
export default __webpack_public_path__ + "static/media/img-placement.a19c7f06747782a4a819ef73eb151a62.svg";
export { ForwardRef as ReactComponent };